module.exports = __webpack_public_path__ + "img/invoice (1).a3e183a6.png";